// Firebase UIDs with elevated access.
//
// Source of truth for the frontend admin allowlist. Mirrors the DB-side
// admin bypass policies in supabase/migrations/20260417000001_admin_bypass_policies.sql
// (extended by 20260514000002_add_admin_bypass_uid.sql and
// 20260514000003_exports_rls_self_view.sql).
//
// Adding someone? Update BOTH this constant AND the migrations so frontend
// filters + DB RLS stay in sync. Consider a `is_admin` column on profiles
// once the list grows past 5 — magic strings don't scale.

export const ADMIN_UIDS: readonly string[] = [
  // Hardcoded admins commented out — admin access now relies on the `admin` /
  // `contractor` custom claim (granted via the Facility Access toggle). Restore
  // any of these if you need a hardcoded fallback.
  // "sXcH7yt8r7VW6EueCzPVdvKalM52", // Mario (legacy)
  // "4g6cS3wnNmTcqAQKeXfI7cFCRiC3", // Admin 2
  // "R3WWkbEt1oe4pkr6vdgLMbRZ2Ng2", // Mario (current)
] as const;

// Platform-admin custom claim, cached at auth. Custom claims aren't readable
// synchronously from the Firebase SDK, so useAuth reads them once via
// getIdTokenResult and primes this cache. A user with the `admin` or
// `contractor` claim (granted via the Facility Access toggle) then behaves
// exactly like a hardcoded ADMIN_UID. `contractor` is kept distinct so its
// behavior can diverge later.
let _claimCache: { uid: string; admin: boolean; contractor: boolean } | null = null;

export const setPlatformAdminClaim = (
  uid: string | null | undefined,
  claim: { admin: boolean; contractor: boolean } | null,
): void => {
  _claimCache = uid && claim ? { uid, admin: claim.admin, contractor: claim.contractor } : null;
};

export const isAdminUser = (uid: string | null | undefined): boolean => {
  if (!uid) return false;
  if (ADMIN_UIDS.includes(uid)) return true;
  return Boolean(
    _claimCache && _claimCache.uid === uid && (_claimCache.admin || _claimCache.contractor),
  );
};
